exports = module.exports = require("../../../../node_modules/@vue/cli-service/node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.pointer[data-v-3e9065e9] {\n  cursor: pointer;\n}\n", ""]);

// exports
